import './HeaderNull.scss'
import { useNavigate } from 'react-router-dom'

function HeaderNull ({ title, link }) {
  const navigate = useNavigate()

  return (
    <header className='header_null'>
      <div className='header_null_main'>
        <div className='header_null_item' onClick={() => navigate(link)}>
          <div className='header_null_back'>
            <span className='header_null_back_btn'>กลับ</span>
          </div>
          <div className='left_slot_null'></div>
        </div>
        <div className='header_null_title'>{title}</div>
        <div style={{ flex: '1' }}></div>
      </div>
    </header>
  )
}

export default HeaderNull
